import types from './types';
import _ from 'lodash';

const reducer = (state, action) => {
  const { payload, type } = action;
  switch (type) {
    case types.STEP_FORWARD:
      return { ...state, step: state.step + 1 };

    case types.STEP_TWO_FORWARD:
      return { ...state, step: state.step + 2 };

    case types.STEP_BACKWARDS:
      return { ...state, step: state.step - 1 };

    case types.SET_STEP:
      return { ...state, step: payload };

    case types.SET_OPERATION_DATA:
      const { parsed, unparsed } = payload;
      return { ...state, operation: { unparsed }, user: { ...parsed } };

    case types.SET_USER_DATA:
      return { ...state, user: { ...payload } };

    case types.SET_CONFIRMATION_DATA:
      const confirmationData = _.merge(state.confirmationData, payload);
      return { ...state, confirmationData: confirmationData };

    case types.SET_CONTRACTS:
      return { ...state, contracts: payload };

    case types.SET_MODAL:
      return { ...state, modal: { ...payload } };

    case types.SET_PHOTO:
      const newPhotos = _.merge(state.photosUri, payload);
      return { ...state, photosUri: newPhotos };

    case types.SET_CAMERA:
      return { ...state, camera: { ...payload } };

    case types.SET_LOADING:
      return { ...state, loading: payload };

    case types.SET_ERROR:
      return { ...state, error: payload  };

    case types.UNSET_ERROR:
      return { ...state, error: payload };

    default:
      return state;
  }
};

export default reducer;
